import { GROUP_KIND_ID } from '@/lib/groups/group-kind'
import { type AnyRecord, asArray, asRecord, finiteNumber } from './tolerant-read'

export function getNsDocument(metadata: unknown): AnyRecord | null {
  const m = asRecord(metadata)

  if (!m) return null
  return (asRecord(m.nsDocument) ?? asRecord(m.NsDocument)) as AnyRecord | null
}

export function getUserLayerElements(nsDocument: AnyRecord): unknown[] {
  const pasteboardElements =
    asRecord(nsDocument.pasteboardElements) ?? asRecord(nsDocument.PasteboardElements)

  if (!pasteboardElements) return []

  const userLayer = asRecord(pasteboardElements.userLayer) ?? asRecord(pasteboardElements.UserLayer)

  if (!userLayer) return []

  const elements = asArray(userLayer.elements) ?? asArray(userLayer.Elements)

  return elements ?? []
}

export function getElementKindId(element: AnyRecord): number | null {
  const kindId = element.kindId ?? element.KindId

  return finiteNumber(kindId)
}

export function getElementObjectId(element: AnyRecord): string | null {
  const objectId = element.objectId ?? element.ObjectId

  return typeof objectId === 'string' ? objectId : null
}

export function getDecodedData(element: AnyRecord): AnyRecord | null {
  return asRecord(element.decodedData) ?? asRecord(element.DecodedData)
}

/** GroupElement protobuf uses `base` under `groupElement`, not always top-level on decodedData. */
export function geometryDecodedRoot(decodedData: AnyRecord, kindId: number): AnyRecord {
  if (kindId !== GROUP_KIND_ID) return decodedData

  const ge = asRecord(decodedData.groupElement) ?? asRecord(decodedData.GroupElement)

  return ge ?? decodedData
}

/** Child rows for a group: wrapper `elements` (checkpoint wire) or nested `elements` on decoded stowed. */
export function layerChildElements(element: AnyRecord, decodedData: AnyRecord): unknown[] {
  const fromWrapper = asArray(element.elements) ?? asArray(element.Elements)

  if (fromWrapper && fromWrapper.length > 0) return fromWrapper

  return asArray(decodedData.elements) ?? asArray(decodedData.Elements) ?? []
}
